<script lang="ts">
  import { onMount } from "svelte";
  import { apiClient } from "./apiClient";
  import { attendantName } from "./stores";

  let showNameDialog = false;
  let newUserName = "";

  onMount(async () => {
    if (!$attendantName) {
      const randomName = await apiClient.getRandomName();
      attendantName.set(randomName);
    }
  });

  const handleUserNameClick = () => {
    newUserName = $attendantName || "";
    showNameDialog = true;
  };

  const handleNameConfirm = () => {
    if (newUserName?.trim().length) {
      attendantName.set(newUserName.trim());
    }
    showNameDialog = false;
    newUserName = "";
  };

  const handleNameCancel = () => {
    showNameDialog = false;
    newUserName = "";
  };
</script>

<p class="menu">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  Du arbeitest als:
  <span id="user-name" on:click={handleUserNameClick}>{$attendantName}</span>
</p>

<!-- Name change dialog -->
{#if showNameDialog}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="dialog-overlay" on:click={handleNameCancel}>
    <div class="dialog" on:click|stopPropagation>
      <h3>Name ändern</h3>
      <p>Wie sollen wir dich oder deinen Arbeitsplatz nennen?</p>
      <!-- svelte-ignore a11y-autofocus -->
      <input
        type="text"
        bind:value={newUserName}
        placeholder="Dein Name..."
        class="name-input"
        on:keydown={(e) => e.key === "Enter" && handleNameConfirm()}
        autofocus
      />
      <div class="dialog-buttons">
        <button class="btn-cancel" on:click={handleNameCancel}>Abbrechen</button
        >
        <button class="btn-confirm" on:click={handleNameConfirm}
          >Speichern</button
        >
      </div>
    </div>
  </div>
{/if}

<style>
  .menu {
    text-align: center;
    padding-left: 5px;
    padding-right: 5px;
  }

  #user-name {
    color: #2563eb;
    cursor: pointer;
    text-decoration: underline;
    text-decoration-style: dotted;
    font-weight: bold;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.2s ease;
    position: relative;
  }

  #user-name:hover {
    background-color: #dbeafe;
    text-decoration-style: solid;
    transform: translateY(-1px);
  }

  #user-name:active {
    transform: translateY(0);
  }

  /* Dialog styles */
  .dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .dialog {
    background: white;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    max-width: 400px;
    text-align: center;
    min-width: 300px;
  }

  .dialog h3 {
    margin: 0 0 15px 0;
    color: #333;
    font-size: 1.5em;
  }

  .dialog p {
    margin: 10px 0 20px 0;
    color: #666;
  }

  .name-input {
    width: 100%;
    box-sizing: border-box;
    padding: 12px 16px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 16px;
    margin-bottom: 20px;
    transition: border-color 0.2s ease;
    font-family: "Content", serif;
  }

  .name-input:focus {
    outline: none;
    border-color: #2563eb;
  }

  .dialog-buttons {
    display: flex;
    gap: 15px;
    justify-content: center;
    margin-top: 20px;
  }

  .dialog-buttons button {
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    transition: all 0.2s ease;
    font-family: "Content", serif;
  }

  .btn-cancel {
    background: #f3f4f6;
    color: #374151;
    border: 2px solid #e5e7eb;
  }

  .btn-cancel:hover {
    background: #e5e7eb;
  }

  .btn-confirm {
    background: #2563eb;
    color: white;
  }

  .btn-confirm:hover {
    background: #1d4ed8;
  }
</style>
